import { render, staticRenderFns } from "./mobile-bind.vue?vue&type=template&id=1da87dbb&scoped=true&"
import script from "./mobile-bind.vue?vue&type=script&lang=js&"
export * from "./mobile-bind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da87dbb",
  null
  
)

export default component.exports